import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataReservation } from '../../data/DataReservation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifierBlocNotaire
    peutAjouterBlocNotaire

    onAffichePanelNotaire : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelNotaire: 'Ajouter un notaire',

    onActiveBoutonEnregistrer: false,

};

export class FicheNotaire extends Component {
    _creationContent = () => {
        return <Panel
            isOpen={this.props.onAffichePanelNotaire}
            headerText={this.state.titrePanelNotaire}
            type={PanelType.medium}
            onDismiss={() => this._onAnnulation()}
            onOpen={() => this._onOpen()}
            closeButtonAriaLabel="Fermer"
            onRenderFooterContent={this._onRenderFooterContent}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divNomNotaire">
                        <EUITextField
                            label="Nom"
                            maxLength={MaxLengths.reservation.nomNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "nomNotaireClient", newValue)}
                            value={this.state.reservation.nomNotaireClient}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divPrenomNotaire">
                        <EUITextField
                            label="Prénom"
                            maxLength={MaxLengths.reservation.prenomNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "prenomNotaireClient", newValue)}
                            value={this.state.reservation.prenomNotaireClient}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" name="divAdresseNotaire">
                        <EUITextField
                            label="Adresse"
                            maxLength={MaxLengths.reservation.adresseNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "adresseNotaireClient", newValue)}
                            value={this.state.reservation.adresseNotaireClient}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" name="divCompNotaire">
                        <EUITextField
                            label="Adresse complément"
                            maxLength={MaxLengths.reservation.complementAdresseNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "complementAdresseNotaireClient", newValue)}
                            value={this.state.reservation.complementAdresseNotaireClient}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md2" name="divCPNotaire">
                        <EUITextField
                            label="CP"
                            maxLength={MaxLengths.reservation.cpNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "cpNotaireClient", newValue)}
                            value={this.state.reservation.cpNotaireClient}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md10" name="divVilleNotaire">
                        <EUITextField
                            label="Ville"
                            maxLength={MaxLengths.reservation.villeNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "villeNotaireClient", newValue)}
                            value={this.state.reservation.villeNotaireClient}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" name="divEmailNotaire">
                        <EUITextField
                            label="Email"
                            maxLength={MaxLengths.reservation.emailNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "emailNotaireClient", newValue)}
                            value={this.state.reservation.emailNotaireClient}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divTelNotaire">
                        <EUITextField
                            label="Téléphone bureau"
                            maxLength={MaxLengths.reservation.telNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "telNotaireClient", newValue)}
                            value={this.state.reservation.telNotaireClient}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divPortableNotaire">
                        <EUITextField
                            label="Téléphone portable"
                            maxLength={MaxLengths.reservation.portableNotaireClient}
                            onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "reservation", "portableNotaireClient", newValue)}
                            value={this.state.reservation.portableNotaireClient}
                        />
                    </div>
                </div>
            </div>
        </Panel>;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit = () => {
        this.setState(objetState);
    }

    _chargementDonnees = () => {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);

        if (idOperationRenseigneeEtDifferent && idReservationRenseigneeEtDifferent) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du notaire'
            });

            let ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

            ficheReservation_Simple
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.titrePanelNotaire = 'Modifier le notaire';

                        stateTemp.reservation = objetData[0];

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                        this._onVerificationFormulaire();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du notaire en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'NotaireReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerNotaire" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    render = () => {
        return this._creationContent();
    }
}